export const defaultExpandingTextConfig = {
  shrinkText: '...Show Less',
  expandText: '...Show More',
  lineHeight: '24',
};
